import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Proovige erinevaid või üldisemaid märksõnu ning veenduge, et kõik sõnad oleksid ilma kirjavigadeta.

  <span style="color:#85c1dc;">**FI:**</span>
  Kokeile erilaisia​​ tai yleisempiä hakusanoja ja varmista, että kaikki sanat on oikein kirjoitettu

  <span style="color:#85c1dc;">**RU:**</span>
  Попробуйте использовать другие или общие ключевые слова и убедитесь, что все слова без ошибок.
*/
/* @__NO_SIDE_EFFECTS__ */
const m18 = msg(
  mf`Proovige erinevaid või üldisemaid märksõnu ning veenduge, et kõik sõnad oleksid ilma kirjavigadeta.`,
  mf`Kokeile erilaisia​​ tai yleisempiä hakusanoja ja varmista, että kaikki sanat on oikein kirjoitettu`,
  mf`Попробуйте использовать другие или общие ключевые слова и убедитесь, что все слова без ошибок.`,
)

export { m18 as 'w.module.categories_search.no_categories_suggestion' }